import React, {useState} from "react";
import emailjs from "emailjs-com";
import { useTranslation } from 'react-i18next';
import "./Main.css";

const initialState = {
    name: "",
    email: "",
    message: "",
};
export const Main = () => {
    const [{ name, email }, setState] = useState(initialState);
    const [isSentError, setSentError] = useState(false);
    const [isSent, setSent] = useState(false);
    const { t } = useTranslation();


    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // LOCAL
            // const response = await fetch("http://localhost:5000/api/email/send", {
            // SERVER
            const response = await fetch("/api/email/send", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({phone: name, email}),
            });
            const data = await response;
            setSent(true);
            setSentError(data.status !== 200);
        } catch (error) {
            setSent(true);
            setSentError(true);
            console.error("Ошибка отправки:", error);
        }
    };
    return (
        <div className="mainPage">
            <div className="descBlock">
                <div className="mainText">
                    {t('titletitle')}
                </div>
                <div className="mainRow">{t('titledesc')}</div>
            </div>
            <div className="formBlock">
                <div className="lighti"></div>
                <div className="section-title-desc">{t('formdesc')}</div>
                <form name="sentMessage" onSubmit={handleSubmit} className="form-form">
                    <div className="form-line">
                        <div className="inputContainer">
                            <input
                                type="tel"
                                id="name"
                                name="name"
                                placeholder={t('formplaceholder1')}
                                pattern="^\+?[1-9]\d{1,25}$"
                                required
                                onChange={handleChange}
                                className="blockGeneratorContentLinkInput"
                            />
                            <p className="help-block text-danger"></p>
                        </div>
                        <div className="inputContainer">
                            <input
                                type="email"
                                id="email"
                                name="email"
                                className="blockGeneratorContentLinkInput"
                                placeholder={t('formplaceholder2')}
                                required
                                onChange={handleChange}
                            />
                            <p className="help-block text-danger"></p>
                        </div>
                        {/*<button*/}
                        {/*    type="submit"*/}
                        {/*    className="blockGeneratorContentGenerateButton"*/}
                        {/*>*/}
                        {/*    <div className="blockGeneratorContentGenerateButtonText">{t('formbutton')}</div>*/}
                        {/*</button>*/}
                    </div>
                    <div className="form-line form-line-b">
                    {
                        isSent ?
                            isSentError ?
                                <div className="section-title-desc">{t('formSentError')}</div>
                                :
                             <div className="section-title-desc">{t('formSentSuccess')}</div>
                            :
                            <button
                                type="submit"
                                className="blockGeneratorContentGenerateButton"
                            >
                                <div className="blockGeneratorContentGenerateButtonText">{t('formbutton')}</div>
                            </button>
                    }
                    </div>
                </form>
            </div>
        </div>
    );
};